import Cookies from 'js-cookie'

const ACCESS_TOKEN_KEY = "access_token";

export const getAccessToken = () => {
  return Cookies.get(ACCESS_TOKEN_KEY);
};

export const saveAccessToken = token => {
  Cookies.set(ACCESS_TOKEN_KEY, token);
};

export const destroyAccessToken = () => {
  Cookies.remove(ACCESS_TOKEN_KEY);
};

export default { getAccessToken, saveAccessToken, destroyAccessToken };